// ============================================================
// LoginPage.js
// Sign-in page for the admin portal. Triggers MSAL redirect
// against the A2Z IT M365 tenant. After return, App.js sees
// the authenticated state and routes the user to /home.
// ============================================================

import React, { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import StatusMessage from '../components/StatusMessage';
import './LoginPage.css';

export default function LoginPage() {
  const { instance } = useMsal();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleLogin = async () => {
    setIsLoading(true);
    setError(null);
    try {
      await instance.loginRedirect(loginRequest);
    } catch (err) {
      setError('Sign in failed. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-page__bg" aria-hidden="true">
        <div className="login-page__mesh" />
        <div className="login-page__orb login-page__orb--1" />
        <div className="login-page__orb login-page__orb--2" />
      </div>

      <div className="login-page__content">
        <div className="login-page__brand">
          <div className="login-page__logo">
            <span className="logo-a">A2Z</span>
            <span className="logo-care">Care</span>
            <span className="logo-hub">Hub</span>
          </div>
          <p className="login-page__tagline">Admin portal</p>
        </div>

        <div className="login-card">
          <h2 className="login-card__title">Sign in to continue</h2>
          <p className="login-card__subtitle">
            A2Z IT staff only. Sign in with your @a2zit.ai account.
          </p>

          {error && (
            <StatusMessage variant="error" className="login-card__error">{error}</StatusMessage>
          )}

          <button
            className="login-card__btn"
            onClick={handleLogin}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="login-card__btn-dots">
                  <span /><span /><span />
                </span>
                Signing in…
              </>
            ) : (
              'Sign in with Microsoft'
            )}
          </button>

          <p className="login-card__help">
            Restricted to authorised A2Z IT personnel.
          </p>
        </div>

        <p className="login-page__footer">A2Z IT — a2zit.ai</p>
      </div>
    </div>
  );
}
